import { render, staticRenderFns } from "./WorkersGrid.vue?vue&type=template&id=1c5bf820"
import script from "./WorkersGrid.vue?vue&type=script&lang=js"
export * from "./WorkersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports